import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ResetPasswordService } from './reset-password.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  providers: [ResetPasswordService]
})
export class ResetPasswordComponent implements OnInit {

  code:string;
  userId:string;
  errorMessage:string = '';
  successMessage:string = '';
  
  form = {
    newPassword:'',
    confirmPassword:''
  }

  constructor(private router:Router, private rpService:ResetPasswordService) {
    router.routerState.root.queryParams.subscribe(data => {
      this.userId = data['userId'];
      this.code = data['code'];
      console.log(data['code']);
    });
  }

  ngOnInit() {

  }

  onSubmitResetPassword(){
    if (this.form.newPassword == '' || this.form.confirmPassword == ''){
      this.errorMessage = 'Complete all fields';
      return;
    }

    if (this.form.newPassword != this.form.confirmPassword) {
      this.errorMessage = 'Passwords do not match';
      return;      
    }

    this.rpService.reset(this.code, this.userId, this.form.newPassword, this.form.confirmPassword).subscribe(
      res => this.resetPasswordSuccess(res),
      error => this.resetPasswordError(error)
    );
  }

  resetPasswordSuccess(res){
    this.router.navigate(['/login']);
  }

  resetPasswordError(error){
    console.log(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/login/reset-password/reset-password.component.ts